module.exports = __webpack_public_path__ + "static/hover-image-b3efa6e2fcd7a27ea0e39e5c87bec2b4.png";